import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { FaUserAlt, FaLock, FaHistory, FaFileAlt, FaGift, FaSignOutAlt } from "react-icons/fa";
import { Image } from "../../../components"; 
import Swal from "sweetalert2";
import Layout from "../../../layout/default";
import "../../../assets/scss/extend/bootstrap/components/_usernavbar.scss";
import Modal from 'react-bootstrap/Modal';
import {  Button } from "react-bootstrap";



function UserNavbar() {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  
  const [modalReferralShow, setModalReferralShow] = useState(false);

  const handleClose = () => setModalReferralShow(false);
  const handleShow = () => setModalReferralShow(true);

  useEffect(() => {
    setIsLoggedIn(localStorage.getItem("isLoggedIn") === "true");
    setUsername(localStorage.getItem("user_name") || "Guest");

    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/shop/auths/login");
  };

  const userId = localStorage.getItem('user_id');
  const userUrl = `${process.env.REACT_APP_API_URL}shop/auths/registration/${userId}`;

  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(userUrl).then(() => {
      // Close the modal after copying the URL
      handleClose();

      // Show success message with SweetAlert2
      Swal.fire({
        icon: 'success',
        title: 'URL copied to clipboard!',
        showConfirmButton: false,
        timer: 1500
      });
    }).catch(err => {
      // Show error message with SweetAlert2
      Swal.fire({
        icon: 'error',
        title: 'Failed to copy',
        text: err.message,
        showConfirmButton: true
      });
    });
  };

  return (
<Layout title="User Navbar">
  <header className="header"> {/* Your header component here */} </header>
  
  <div className="user-navbar-container">
    <Dropdown.Menu show className={`dropdown-menu-custom ${isMobile ? "mobile-view" : ""}`}>
      <div className="dropdown-header">
        <Image
          src="/images/avatar/profile-img.png"
          staticImage
          thumbnail
          className="profile-img"
        />
        <h5 className="username">{username}</h5>
      </div>

      <Dropdown.Item onClick={() => navigate("/shop/admin/profile")}>
        <FaUserAlt className="icon" /> My Profile
      </Dropdown.Item>
      <Dropdown.Item onClick={() => navigate("/shop/change-password")}>
        <FaLock className="icon" /> Change Password
      </Dropdown.Item>
      <Dropdown.Item onClick={() => navigate("/shop/auths/User-Comission")}>
        <FaHistory className="icon" /> Commission History
      </Dropdown.Item>
      <Dropdown.Item onClick={() => navigate("/shop/auths/terms-and-conditions")}>
        <FaFileAlt className="icon" /> Terms & Conditions
      </Dropdown.Item>

      <Dropdown.Item onClick={handleShow}>
        <FaGift className="icon" /> Refer & Earn
      </Dropdown.Item>

      <Dropdown.Item onClick={handleLogout} className="logout-item">
        <FaSignOutAlt className="icon" /> Logout
      </Dropdown.Item>
    </Dropdown.Menu>
  </div>

  <footer className="footer"> {/* Your footer component here */} </footer>
  <Modal show={modalReferralShow} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Refer and Earn</Modal.Title>
        </Modal.Header>
        <Modal.Body>{userUrl}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleCopyToClipboard}>
            Copy
          </Button>
        </Modal.Footer>
      </Modal>
</Layout>

  );
}

export default UserNavbar;
